// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__13nnD","content":"styles_content__lKhmE"};